export default ({ roles = [], role } = {}) => {
  return roles.includes(role);
};
